module.exports = __webpack_public_path__ + "static/media/fitting-recipes.8e00c5f0.svg";